export default "__VITE_ASSET__CZyTf3T1__"